"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformCartMetadatatoBffInput = void 0;
var transformCartMetadatatoBffInput = function (redirectUrl) {
    return {
        paymentMetadata: {
            redirectUrl: redirectUrl,
        },
    };
};
exports.transformCartMetadatatoBffInput = transformCartMetadatatoBffInput;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/checkout-sdk/dist/lib-esm/modules/common/transforms/transformCartMetadatatoBffInput.js
// module id = 3380
// module chunks = 11